import Breadcrumb from "../components/Breadcrumb";
import Roles from "../components/Roles";

const RolesPage = () => {
  return (
    <>
      {/* Breadcrumb */}
      <Breadcrumb title="Roles" />

      {/*All Clients Layer*/}
      <Roles />
    </>
  );
};

export default RolesPage;
